import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from 'redux/actions/sessionActions';
import { Translate, I18n } from 'react-redux-i18n';
import alertify from 'alertifyjs';
import { confirmDialog } from 'utils/confirmDialog';

const CONFIRM_TEXT = 'DELETE';

const DeleteAccount = (props) => {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);

  const canSubmit =
    password.trim().length > 0 &&
    confirmation.trim().toUpperCase() === CONFIRM_TEXT;

  const runDelete = async () => {
    if (!canSubmit || busy) {
      return;
    }
    setBusy(true);
    try {
      await props.deleteAccount({
        password: password.trim(),
        confirmation: confirmation.trim(),
      });
      alertify.success(I18n.t('delete_account_success'));
      props.history.push('/login');
    } catch (error) {
      alertify.error(error.message || I18n.t('try_later'));
    } finally {
      setBusy(false);
    }
  };

  const handleDelete = () => {
    confirmDialog({
      title: I18n.t('delete_account_confirm_title'),
      message: I18n.t('delete_account_confirm_message'),
      onConfirm: () => runDelete(),
      okLabel: I18n.t('delete_account_button'),
      cancelLabel: I18n.t('cancel'),
      variant: 'danger',
    });
  };

  return (
    <div className="account-panel account-panel--danger account-delete-panel">
      <h2 className="account-panel-title">
        <Translate value="delete_account_title" />
      </h2>
      <p className="account-panel-subtitle">
        <Translate value="delete_account_subtitle" />
      </p>
      <p className="account-delete-warning">
        <Translate value="delete_account_warning" />
      </p>

      <form
        className="account-delete-form"
        autoComplete="off"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          type="text"
          name="ebi_autofill_trap_user"
          autoComplete="username"
          tabIndex={-1}
          aria-hidden="true"
          className="account-autofill-trap"
          defaultValue=""
        />
        <input
          type="password"
          name="ebi_autofill_trap_pass"
          autoComplete="current-password"
          tabIndex={-1}
          aria-hidden="true"
          className="account-autofill-trap"
          defaultValue=""
        />
        <div className="account-field">
          <label htmlFor="delete-account-password">
            <Translate value="password_current" />
          </label>
          <input
            id="delete-account-password"
            name="ebi_delete_account_password"
            type="password"
            autoComplete="off"
            readOnly
            value={password}
            onFocus={(e) => e.target.removeAttribute('readonly')}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
        </div>
        <div className="account-field">
          <label htmlFor="delete-account-confirmation">
            <Translate value="delete_account_type_delete" />
          </label>
          <input
            id="delete-account-confirmation"
            name="ebi_delete_account_confirm"
            type="text"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={CONFIRM_TEXT}
            autoComplete="off"
            readOnly
            onFocus={(e) => e.target.removeAttribute('readonly')}
            disabled={busy}
          />
        </div>
        <div className="account-actions">
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={busy || !canSubmit}
          >
            {busy ? '...' : <Translate value="delete_account_button" />}
          </button>
        </div>
      </form>
    </div>
  );
};

DeleteAccount.propTypes = {
  deleteAccount: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  deleteAccount: (payload) => dispatch(actions.deleteAccount(payload)),
});

export default connect(null, mapDispatchToProps)(withRouter(DeleteAccount));
